import React from "react";

import { HeaderStoryblok } from "../../types/storyblok";
import { Box } from "../../base/Box/Box";
import { StoryblokImage } from "../../base/StoryblokImage/StoryblokImage";
import isDarkColour from "../../utils/isDarkColour";
import Link from "../../base/Link/Link";
import { HeaderNavLinksList } from "./components/HeaderNavLinksList/HeaderNavLinksList";
import { HeaderNavLink } from "./components/HeaderNavLink/HeaderNavLink";
import { SmallNavigation } from "../SmallNavigation/SmallNavigation";

const Header = ({
  navLinks = [],
  homeLink,
  logo,
  logoLight,
  colourScheme = "white"
  }: HeaderStoryblok) => {
  return (
    <Box as="header" colourScheme={colourScheme} blockSpacing bkg>
      <Box
        as="div"
        className="z-40 mx-auto flex max-w-standard flex-nowrap items-center justify-between pt-7 lg:pt-14"
      >
        <Box as="div" className="">
          <Link href={homeLink}>
            <StoryblokImage
              src={isDarkColour(colourScheme) ? logoLight : logo}
              maxWidth={400}
              mode="responsive"
              alt="Founders Factory logo"
              className="h-8 md:h-11"
              assetClassName="!w-auto"
            />
          </Link>
        </Box>
        <Box as="div" className="z-40">
          <Box
            as="ul"
            className="hidden h-full flex-row items-center gap-10 lg:flex"
          >
            {navLinks
              ?.filter((block) => !!block.title)
              ?.map((block) => {
                if (block.component === "HeaderNavLink") {
                  return (
                    <HeaderNavLink
                      component={block?.component}
                      _uid={block?._uid}
                      key={block?._uid}
                      link={block?.link}
                      title={block?.title}
                      variant={block?.variant}
                      className="text-p1 hover:opacity-80"
                    />
                  );
                }

                if (block.component === "HeaderNavLinksList") {
                  return (
                    <HeaderNavLinksList
                      component={block?.component}
                      _uid={block?._uid}
                      key={block?._uid}
                      title={block.title}
                      subLinks={block.subLinks}
                      className="text-p1 hover:opacity-80"
                    />
                  );
                }

                return null;
              })}
          </Box>
          <SmallNavigation navLinks={navLinks} />
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
